import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import VueRouter from 'vue-router'

import AddLocation from './locations/LocationInformation.vue'
import ImageUpload from './locations/LocationImageUpload.vue'
import AskAnExpert from './site-content/AskAnExpert.vue'

// Pages
import Home from './pages/home.vue'
import PendingLocations from "./pages/pending-locations";

import HomePage from "./site-content/HomePage"
import Posters from "./site-content/Posters";
import CookiePolicy from "./site-content/CookiePolicy";
import Careers from "./site-content/Careers";
import TermsAndConditions from "./site-content/TermsAndConditions";
import PrivacyPolicy from "./site-content/PrivacyPolicy";
import LocationImages from './locations/LocationImages.vue'
import AttributePage from './Attributes.vue'
import LocationSearch from './locations/Locations.vue'
import Information from './site-content/Information.vue'
import Collections from './site-content/Collections.vue'
import OwnerInformation from "./locations/OwnerInformation";
import LocationAttributes from "./locations/LocationAttributes";

import BannerImages from "./site-content/BannerImages";
import DeletedPortfolios from "./DeletedPortfolios";
import Login from './Login.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import draggable from 'vuedraggable'
import babelPolyfill from 'babel-polyfill'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import CKEditor from '@ckeditor/ckeditor5-vue'
import VueMoment from 'vue-moment'
import ContentLayout from './layouts/content-layout'
import {imgixUrl} from './imgix'




library.add(fas)

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.use(babelPolyfill)
Vue.use(CKEditor)
Vue.use(VueMoment);
Vue.prototype.$imgix = imgixUrl;

Vue.component('login', Login)
Vue.component('location-information', AddLocation)
Vue.component('image-upload', ImageUpload)
Vue.component('location-images', LocationImages)
Vue.component('draggable', draggable)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('owner-information', OwnerInformation)
Vue.component('location-attributes', LocationAttributes)
Vue.component('content-layout', ContentLayout)

Vue.config.productionTip = false

// Defines the routes available.
const routes = [
  // { path: '/', name: 'home', component: Home },
  {path: '/', name: 'home', component: Home},
  {path: '/locations/:locationRef?', name: 'locations', component: LocationSearch},
  {path: '/addlocation', name: 'addlocation', component: AddLocation},
  {path: '/imageupload', name: 'imageupload', component: ImageUpload},
  {path: '/attributes', name: 'attributepage', component: AttributePage},
  // Was "About" until 2026-10-15; the path stays /about so bookmarks keep working.
  {path: '/about', name: 'about', component: AskAnExpert},
  {path: '/information', name: 'information', component: Information},
  {path: '/collections', name: 'collections', component: Collections},
  {path: '/homepage', name: 'homepage', component: HomePage},
  {path: '/posters', name: 'posters', component: Posters},
  {path: '/pending-locations', name: 'pending-locations', component: PendingLocations},
  {path: '/cookiepolicy', name: 'cookiePolicy', component: CookiePolicy},
  {path: '/terms', name: 'termsAndConditions', component: TermsAndConditions},
  {path: '/privacypolicy', name: 'privacyPolicy', component: PrivacyPolicy},
  {path: '/bannerImages', name: 'bannerImages', component: BannerImages},
  {path: '/deletedPortfolios', name: 'deletedPortfolios', component: DeletedPortfolios},
  {path: '/careers', name: 'careers', component: Careers},

  // { path: '/addlocation', component: Users},
];

// Sets up router
const router = new VueRouter({
  routes,
});

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js